import React, { useState } from "react";
import Spinner from "../reusables/spinner";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
  approve_supplier,
  restore_account,
  restore_supplier,
  verify_customer,
} from "../../redux/actions/adminActions";

function RestoreModal({
  show,
  handleClose,
  users,
  customer,
  restore,
  accessToken,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleLoading = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 5000);
  };

  const handleRestore = (id) => {
    handleLoading();
    if (customer) {
      restore(id, accessToken, handleClose, "customer");
    } else {
      restore(id, accessToken, handleClose, "supplier");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
        <i class="ri-close-line sectionText--small"></i>
      </div>
      <div className="sectionHeight--mid center">
        <div className="w-100 vAlign">
          <h2 className="sectionText--mid">
            Are you sure you want to {customer ? "verify" : "restore"}{" "}
            {users?.length > 1 ? "these" : "this"} user
            {users?.length > 1 && "s"}?
          </h2>

          <div className="pt-3 center">
            {isLoading ? (
              <div className="center">
                <Spinner dark />
              </div>
            ) : (
              <div>
                <button className="btn__filled mx-2 hasRadius">
                  No, Cancel
                </button>
                <button
                  className="btn__transparent"
                  onClick={() => handleRestore(users)}
                >
                  Yes Restore
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  restore: (id, token, success, type) =>
    dispatch(restore_account(id, token, success, type)),
  //   verify: (id, token, success) => dispatch(verify_customer(id, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RestoreModal);
